import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.market_view_show_page', () => {
  import('./internal/market_view_show_page').then(({ default: Component }) => Component());
});
